<template>
  <section
    ref="scrollBody"
    class="d-flex flex-column justify-content-between align-content-center h-full"
  >
    <perview-file v-if="isFilePriview" v-bind:file="filePriviewData" @closePopup="closePopup"></perview-file>
  	<div class="pdt-24 shadow-bottom" v-if="status === 'REJECT'">
      <div class="container container--narrow">
        <div class="d-flex mgl-8 mgr-8">
          <div>
            <span class="w-40 mgl-8 mgr-8 h-40 d-flex justify-content-center align-items-center notification-icon">
            <i class="material-icons  mb-36 t-color-secondaryBtnText">notifications</i>
            </span>
          </div>
          <div class="t-body2 mgl-8 mgr-8">
            {{$t('3489')}}
          </div>
        </div>
        <div class="mgt-5 pdb-8 mgl-16 mgr-16 d-flex flex-row-reverse">
          <span class="mdc-button t-body3 t-color-secondaryBtnText" @click="moveUpdate()" @keypress="moveUpdate()" tabindex="0">
            {{$t('3476')}}
          </span>
        </div>
      </div>
		</div>

    <div class="pdt-24 shadow-bottom" v-if="status === 'UNDER_EVALUATION'">
      <div class="container container--narrow">
        <div class="d-flex mgl-8 mgr-8">
          <div>
            <span class="w-40 mgl-8 mgr-8 h-40 d-flex justify-content-center align-items-center notification-icon">
            <i class="material-icons  mb-36 t-color-secondaryBtnText">notifications</i>
            </span>
          </div>
          <div class="t-body2 mgl-8 mgr-8">
            {{$t('3482')}}
          </div>
        </div>
        <div class="mgt-5 pdb-8 mgl-16 mgr-16 d-flex flex-row-reverse">
          <span class="mdc-button t-body3 t-color-secondaryBtnText" @click="moveScrollBottom()" @keypress="moveScrollBottom()" tabindex="0">
            {{$t('3483')}}
          </span>
        </div>
      </div>
		</div>


    <main class="position-relative flex-grow-1 scroll-y">
      <div class="container container--narrow">
        <div class="pda-16">

          <div
            class="d-flex bg-documentGray b-radius8 pda-16 justify-content-between align-items-center"
          >
              <div
                :class="scoreClassForStatus"
                  class="lerner-list-status-tag tag-big t-helper font-r t-line-18 pdt-5 pdb-5 pdr-12 pdl-12 t-color-white d-flex align-items-center">

                    <i class="material-icons icon15 pdr-8" v-if="isUsingImage">
                      <img src="@/images/mission/process-check-white.svg" alt="" v-show="status === 'SUBMITTED'" />
                      <img src="@/images/mission/process-done-white.svg" alt="" v-show="status === 'UNDER_EVALUATION'" />
                    </i>

                    <i class="material-icons icon15 pdr-8" v-else>{{ materialTextForStatus }}</i>
                <div class="t-body2 font-r t-line-h-22 l-spacing42">
                  {{ currentTranslateForStatus }}
                </div>
              </div>
            <div class="d-flex ">
              <div v-if="status === 'SUBMITTED'" class="dash-color t-headline3 t-line-h-24 font-b">
                -
              </div>
              <div v-else class="t-headline3 t-line-h-24 font-b" :class="scoreTextColorForStatus">
                {{ eval !== null ? eval.score : '-' }}
              </div>
              <div class="d-flex align-items-baseline">
                <div class="t-body1 pdl-4 pdr-4 t-color-bodyGrayB">/</div>
                <div class="t-body1 t-color-bodyGrayB font-r">100</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pdt-4 pdl-16 pdr-16">
          <div class="d-flex align-items-baseline justify-content-between">
            <div
              class="t-subtitle2 t-line-h-24 l-spacing48 font-b t-color-headlineBlack"
            >
              {{ $t("3474") }}
            </div>
            <div class="t-body3 t-line-h-22 l-spacing48 font-r t-color-bodyGrayA">
              <!--  {{ $t("3475", { str: $moment(answer.date).format('L') }) }} -->
              {{ submitDateText }}
            </div>
          </div>
          <div
            id="answerEl"
            class="mgt-16 mgb-8 w-full mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth mdc-text-field--disabled disabled--Updated"
          >
            <textarea
              id="textarea"
              ref="answerTextarea"
              rows="auto"
              :value="answerText"
              readonly="readonly"
              disabled="disabled"
              class="mdc-text-field__input pdt-16 pdb-16 t-body3 font-r t-line-h-22 l-spacing36 t-color-textfieldDisabledText mgt-0"
            ></textarea>
            <div class="mdc-notched-outline mdc-notched-outline--no-label">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch"></div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>
          </div>
        </div>
        <ul class="mdc-list pdt-0 pdb-0">
          <li
            class="mdc-list-item align-items-center pdr-4 pdt-2 pdb-2"
            tabindex="0"
            v-for="(refData, index) in answer.file"
            :key="index + 'dref'"
          >
            <!-- v-for="(refData, index) in missionData.reference"
            :key="index + 'dref'" -->
            <span class="mdc-list-item__ripple"></span>
            <span
              class="mdc-list-item__graphic material-icons t-color-secondaryBtnText icon15 pdr-8 mgr-0 font16"
              aria-hidden="true"
              >attach_file</span
            >
            <span
              class="mdc-list-item__text flex-grow-1 t-body3 t-color-signBlue t-line-h-24 l-spacing48 t-line-1 font-r"
              @click="fileDisplay(refData)"
              >{{ refData.originalName }}</span
            >
            <span aria-hidden="true" class="mdc-list-item__meta">
              <button
                @click="fileDisplay(refData)" @keypress="fileDisplay(refData)"
                class="mdc-icon-button material-icons mgr--16 t-color-iconInactive"
              >
                download
              </button>
            </span>
          </li>
        </ul>
        <div class="pdt-24 pdb-16 pdl-16 pdr-16">
          <button
            class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8 b-radius4"
            @click="moveUpdate()" @keypress="moveUpdate()"
          >
            <span class="mdc-button__ripple"></span>
            <span class="mdc-button__label t-color-white font-m">{{
              $t("3476")
            }}</span>
          </button>
          <button
            type="button"
            class="mdc-button mdc-dialog__button"
            data-mdc-dialog-action="discard"
            @click="showHistoryPopup"
          >
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-color-secondaryBtnText font-m">{{
              $t("3477")
            }}</span>
          </button>
        </div>


        <div class="pdl-16 pdr-16 pdt-34 no-last-border">
          <div
            class="t-subtitle2 t-line-h-24 l-spacing48 font-b t-color-headlineBlack mgb-16"
          >
            {{ $t("122") }}
          </div>

          <div
            class="mgt-3 mgb-16"
            v-if="feedbackList != '' && feedbackList.length > 0"
          >
            <div v-for="(feedback, index) in feedbackList" :key="index" class="feedbackList">
              <div
                class="d-flex flex-row justify-content-between "
              >
                <member-profile
                  :profile="feedback.member !== null ? feedback.member.profile : ''"
                  :owner="feedback.owner"
                  :memberId="feedback.member.id"
                  class="mgr-8"
                > {{ feedback.member && feedback.member.name ? $t('3437', {first: feedback.member.name.first, last: feedback.member.name.last}).charAt(0).toUpperCase() : "" }}
                </member-profile>

                <div class="flex-grow-1">
                  <div class="pdl-8 d-flex flex-grow-1">
                    <div class="t-body3 t-color-headlineBlack font-r t-line-h-20 l-spacing32">
                      <div class="d-flex flex-wrap">
                        {{ $t('3437', {first: feedback.member.name.first, last: feedback.member.name.last}) }}
                        <span class="t-caption t-color-linkBlue mgr-8 mgl-8" v-if="!feedback.owner">
                          {{$t("3481")}}
                        </span>
                        <span class="t-caption t-color-bodyGrayA mgr-8 mgl-8">
                          {{ $moment(feedback.date).fromNow() }}
                          <!-- {{feedback.date}} -->
                        </span>
                      </div>
                      <div class="t-body3 t-color-bodyGrayA mgt-4">
                        {{ feedback.text }}
                      </div>
                    </div>
                  </div>

                </div>
                <div class="pdl-8 position-relative mdc-menu-anchor menu-container h-24 pdl-16">
                  <button
                  v-if="feedback.owner"
                  class="d-flex align-items-center"
                  @click.stop="toggleMore" @keypress.stop="toggleMore"
                  >
                  <i
                  class="material-icons js--dropdown-toggle t-color-bodyGrayA more_vert cursor-pointer"
                  >more_horiz
                  </i>
                </button>

                  <div class="mdc-menu mdc-menu-surface toggle-menu toggle-menu-up right-button">
                    <ul
                      class="mdc-list mgl-2 mgr-2"
                      role="menu"
                      aria-hidden="true"
                      aria-orientation="vertical"
                      tabindex="-1"
                    >
                      <li
                        class="mdc-list-item min-h-48 d-flex align-items-center"
                        role="menuitem"
                        @click="deleteFeedback(feedback.id)" @keypress="deleteFeedback(feedback.id)" tabindex="0"
                      >
                        <span class="mdc-list-item__ripple"></span>
                        <span
                          class="mdc-list-item__text t-body1 font-r t-color-headlineBlack"
                        >
                          <!-- Todo 다국어 코드 변경 -->
                          {{ $t("1347") }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="mgt-16 mgb-16 divider mgl-56" v-if="index < feedbackList.length - 1"></div>
            </div>
            <div ref="scrollBottom"></div>
          </div>
          <div class="">
            <label
              class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea multiline-text-field customize-input w-full"
              id="email"
            >

            <div class="mdc-notched-outline">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch">
                <label
                  class="mdc-floating-label t-body3 font-r t-color-textfieldGuid labelResiableText"
                  id="my-label-id"
                >{{$t("3478") }}</label>
              </div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>

            <span class="mdc-text-field__resizer min-h-46">
            <textarea
                class="mdc-text-field__input t-color-headlineBlack t-body3 font-r l-spacing42 t-line-h-22 multilinetextArea min-h-46 pdt-16 pdb-16 pdl-16 pdr-16 resiableTextAreaHeightAdj"
                id="multilinetextArea"
                aria-labelledby="my-label-id"
                rows="1"
                cols="40"
                maxlength="200"
                @input="feedBackTextValidate"
                :value="feedBackText"
              >
              </textarea>
            </span>
          </label>

          <div ref="scrollBody"></div>

          <div class="t-right mgt-16 mgb-34">
            <button
              class="mdc-button mdc-button--raised bg-mainBtn  b-radius4"
              :class="feedBackText === '' ? 'bg-disableBtn' : 'bg-mainBtn'"
              :disabled="feedBackText === '' ? true : false"
              @click="sendFeedback" @keypress="sendFeedback"
            >
              <span class="mdc-button__ripple"></span>
              <span
                class="mdc-button__label  font-m"
                :class="
                  feedBackText === '' ? 't-color-disableBtnText' : 't-color-white'
                "
              >
                {{ $t("1324") }}
              </span>
            </button>
          </div>
        </div>
        </div>
    </div>
        <!-- History Popup Start -->
        <div
          class="mdc-dialog d-flex"
          data-mdc-auto-init="MDCDialog"
          v-if="showModal"
        >
          <div
            class="mdc-dialog__container"
            style="opacity: 1; transform: scale(1)"
          >
            <div
              class="mdc-dialog__surface"
              role="alertdialog"
              aria-modal="true"
              aria-labelledby="my-dialog-title"
              aria-describedby="my-dialog-content"
              style="max-width: 280px"
            >
              <div
                class="mdc-dialog__title t-headline7 font-m l-spacing6 t-line-h-34 pdl-20 pdb-22"
                id="my-dialog-title"
              >{{$t("3494")}}
              </div>
              <div class="divider"></div>
              <div
                class="mdc-dialog__content pdl-8 pdr-8 pdt-0 pdb-4"
                id="my-dialog-content"
                style="max-height: 246px"
              >
                <ul class="mdc-list mdc-list--avatar-list scroll-y pdb-4">
                  <li
                    class="mdc-list-item d-flex justify-content-between w-auto no-selection pdt-11 pdb-11"
                    v-for="(history, index) in historyDatas"
                    :key="index + 'hd'"
                  >
                    <div
                      class="t-body3 l-spacing48 t-line-h-24 font-r t-color-disableBtnText t-color-headlineBlack"
                    >
                      <!-- Todo Naresh work required  -->
                      {{ translateForStatus(history.type.value) }}
                    </div>
                    <div
                      class="t-nowrap t-right t-body3 t-color-bodyGrayA l-spacing48 t-line-h-24"
                    >
                      {{ dayFormatter(history.created) }}
                      {{ timeFormat(history.created) }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="divider"></div>
              <div class="mdc-dialog__actions flex-column pdt-28">
                <div class="d-flex justify-content-end w-full">
                  <button
                    type="button"
                    class="mdc-button mdc-dialog__button"
                    data-mdc-dialog-action="discard"
                    tabindex="0"
                    @click="showOrHideHistory" @keydown="showOrHideHistory"
                  >
                    <div class="mdc-button__ripple"></div>
                    <span
                      class="mdc-button__label t-color-secondaryBtnText font-r"
                    >
                      {{ $t("3499") }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="mdc-dialog__scrim" style="opacity: 1"></div>
        </div>
        <!-- History Popup End -->

    </main>
  </section>
</template>

<script>
/**
 * 나의 학습 상세 - 미션 피드백 컴포넌트(my learning view - mission feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import mainApi from "@/api/mainApi.js";
import learnApi from "@/api/learnApi.js";
import NoData from "../../common/NoData.vue";
import MemberProfile from "@/components/common/MemberProfileCrown.vue";
import { utilDateMixin } from "@/mixins/dateUtil.js";
import { MDCTextField } from "@material/textfield";
import PerviewFile from "@/components/board/PerviewFile.vue";
import {fileMixin} from "@/mixins/file";

const historyStatusMap = new Map();
historyStatusMap.set('SUBMITTED', '3495');
historyStatusMap.set('EVALUATED', '3496');
historyStatusMap.set('COMPLETE', '3497');
historyStatusMap.set('REJECT', '3498');
historyStatusMap.set('RESUBMIT', '3500');

const MISSION_STATUS = {
  REJECT: {
    materialText: "warning",
    translateKey: "3491",
    scoreTextColor: "t-color-lectureRed",
    scoreClass: "bg-lectureRed",
  },
  SUBMITTED: {
    materialText: "process-check-white",
    translateKey: "3473",
    scoreTextColor: "t-color-examBlue",
    scoreClass: "bg-examBlue",
  },
  UNDER_EVALUATION: {
    materialText: "process-done-white",
    translateKey: "3484",
    scoreTextColor: "t-color-lectureAqua",
    scoreClass: "bg-lectureAqua",
  },
  EVALUATED: {
    materialText: "check",
    translateKey: "3493",
    scoreTextColor: "t-color-contentBlue",
    scoreClass: "bg-contentBlue",
  },
};

export default {
  props: [
    "name",
    "description",
    "reference",
    "answer",
    "eval",
    "submissionDateStart",
    "submissionDateEnd",
    "answerText",
    "status",
  ],

  data() {
    return {
      learnId: null,
      feedbackId: null,
      assignmentId: null,
      feedbackList: [],
      dataLoadState: false,
      text: "",
      feedBackText: "",
      feedBackMemberData: null,
      memberData: null,
      firstName: null,
      lastName: null,
      fullName: null,
      profileImage: null,
      owner: null,
      email: "",
      getData: "",
      showModal: false,
      historyDatas: [],
      statusData: MISSION_STATUS,
      isFilePriview: false,
      filePriviewData: null,
    };
  },

  mixins: [utilDateMixin, fileMixin],

  components: {
    "no-data": NoData,
    "member-profile": MemberProfile,
    "perview-file": PerviewFile
  },

  mounted() {
    let scrollBody = this.$refs.scrollBody;
    scrollBody.addEventListener('click', () => {
      let field = document.querySelector(".mdc-menu-surface--open");
      if(field) {
        field.classList.toggle("mdc-menu-surface--open");
      };
    });

    new MDCTextField(document.getElementById('email'));
    this.multilinetextAreaHeightController();

    this.learnId = this.$route.params.learnId;
    this.assignmentId = this.$route.params.assignmentId;

    mainApi.fetMember().then((response) => {
      this.memberData = response.data.data;

      this.firstName = this.memberData ? this.memberData.name.first : "";
      this.lastName = this.memberData ? this.memberData.name.last : "";
      this.fullName = this.memberData ? this.memberData.name.fullName : "";
      this.email = this.memberData.userId;
      // this.nameFormat(this.firstName, this.lastName);
      this.profileImage = this.memberData ? this.memberData.profile : "";
    });
    this.fatchData();
    this.feedbackData();
    this.$nextTick(() => {
      this.$refs.answerTextarea.setAttribute('style', `height:${this.$refs.answerTextarea.scrollHeight + 20}px`);
    });
  },

  computed: {
    isText() {
      return !!this.text;
    },

    submitDateText() {
      const translateKey =
          this.isResubmit() ? "3492" : "3475";

      return this.$t(translateKey, { str: this.dayFormatter(this.answer.date) });
    },

    isUsingImage() {
      const imageStatus = ['SUBMITTED', 'UNDER_EVALUATION'];
        return this.status && imageStatus.includes(this.status);
    },

    scoreClassForStatus() {
      return this.getStatus().scoreClass;
    },

    scoreTextColorForStatus() {
      return this.getStatus().scoreTextColor;
    },

    materialTextForStatus() {
      return this.getStatus().materialText;
    },

    currentTranslateForStatus() {
      return this.$t(this.getStatus().translateKey);
    },

    nameFormat(name) {
      if(name.first) {
        let fullName = this.$t('3437', {first: name.first, last: name.last});
          return fullName.charAt(0);
        } else {
          let fullName = name.fullName;
          return fullName.charAt(1);
        };
    }
  },

  methods: {
    // 피드백 목록 API 호출(get feedback list data)
    fatchData() {
      this.dataLoadState = true;
    },

    isResubmit() {
      return this.answer && this.answer.currentAction === 'RESUBMIT';
    },

    multilinetextAreaHeightController(){
      var tx = document.getElementsByClassName('multilinetextArea');
        for (var i = 0; i < tx.length; i++) {
        tx[i].setAttribute('style', 'height:' + (tx[i].scrollHeight) + 'px;overflow-y:hidden;');
        tx[i].addEventListener("input", OnInput, false);
      }

      function OnInput(e) {
          this.style.height = 'auto';
          this.style.height = (this.scrollHeight) + 'px';
      }
    },

    feedbackData() {
      let params = this.setParams();

      learnApi
        .learnViewMissionFeedback(params)
        .then((response) => {
          this.feedbackList = response.data.data;
        })
        .catch((err) => {
          let responseData = err.response.data.meta;
          this.$error({ content: responseData.errMsg }).then(() => {});
        });
    },

    feedBackTextValidate(e) {
      this.feedBackText = e.target.value;
    },

    showOrHideHistory() {
      this.showModal = !this.showModal;
    },

    showHistoryPopup() {
      this.showOrHideHistory();
      learnApi
        .learnMissionHistory(this.answer.id)
        .then((response) => {
          this.historyDatas = response.data.data;
          this.historyDatas = this.historyDatas.reverse();
        })
        .catch((err) => {
          this.$error({ content: err }).then(() => {});
        });
    },

    toggleMore(evt) {
      let field = evt.target
        .closest(".mdc-menu-anchor")
        .querySelector(".toggle-menu");

      let toggleField = document.querySelector(".mdc-menu-surface--open");
        if(toggleField) {
            toggleField.classList.remove("mdc-menu-surface--open");
        };
      field.classList.toggle("mdc-menu-surface--open");
    },

    // 수정 이동(move update)
    moveUpdate() {
      this.$router.push({
        name: "LearnViewMissionUpdate",
        params: {
          learnId: this.$route.params.learnId,
          assignmentId: this.$route.params.assignmentId,
          answerId: this.answer.id,
        },
        query: this.$route.query,
      });
    },

    getStatus() {
      return this.statusData[this.status];
    },

    getFirstLetter(name) {
      let firstCharOfName = name.trim().slice(0, 1);
      return firstCharOfName;
    },

    // 피드백 등록 (regist feedback)
    sendFeedback() {
      if (this.feedBackText === "") {
        return;
      }

      const params = {
        learnId: this.$route.params.learnId,
        assignmentId: this.$route.params.assignmentId,
        text: this.feedBackText,
      };

      learnApi.learnViewMissionFeedbackSubmit(params).then((response) => {
        this.feedbackData();
        this.feedBackText = "";
      })
    },

    // 피드백 삭제 (delete feedback)
    deleteFeedback(feebackId) {
      this.feedbackId = feebackId;
      // this.feedbackList = [];
      let params = this.setParams();
        this.$confirm({
          content: this.$t('3486'),
          accept: this.$t('3488'),
          cancel: this.$t('3487')
        }).then(() => {
        learnApi
          .learnViewMissionFeedbackDelete(params)
          .then((response) => {
            this.$hideLoading();
            this.feedbackData();
          })
          .catch((err) => {
            this.$hideLoading();
            console.log("err=>", err);
          });
      });
    },

    // 첨부 파일 다운로드
    fileDisplay(fileData) {
      const isPreview = this.isPreviewExt(fileData);
      if (isPreview) {
        localStorage.setItem("socialFile", JSON.stringify(fileData));
        // Preview of image and video
        this.isFilePriview = true;
        this.filePriviewData = fileData;
      } else {
        this.donwloadAttachment(fileData);
      }
    },

    closePopup() {
      this.isFilePriview = false;
    },

    isPreviewExt(fileData) {
      let previewExt = ["image", "video"];
      previewExt = previewExt.filter(
        (data) => fileData.contentType.indexOf(data) > -1
      );
      return previewExt.length > 0;
    },

    translateForStatus(typeValue) {
      return this.$t(historyStatusMap.get(typeValue));
    },

    // 스크롤 바닥으로 이동(move scroll to bottom)
    moveScrollBottom() {
      let element = this.$refs.scrollBottom;
      element.scrollIntoView({behavior: 'smooth'});
    },

    // 파라미터 설정(set parameter)
    setParams() {
      let params = {
        learnId: this.learnId,
        assignmentId: this.assignmentId,
        text: this.text,
        feedbackId: this.feedbackId
      };
      return params;
    },
  },
};
</script>

<style scoped>

.newpros {
  border-radius: 50%;
  overflow: hidden;
}

.mdc-notched-outline__notch {
  min-width: 96px !important;
}

.dash-color {
  color: var(--Examblue);
}

</style>
